import { styled, Tooltip as BaseTooltip } from '@material-ui/core'

export const TooltipWrapper = styled('span')({
  '& .MuiTooltip-popper': {
    '& .MuiTooltip-tooltip': {
      margin: 0,
    },
  },
})

export const Tooltip = styled(BaseTooltip)(({ theme }) => ({
  '& .MuiTooltip-popper': {
    marginBottom: theme.spacing(1.2),
  },
}))
